import { c as _c } from "react/compiler-runtime";
interface NegativeVotingToggleProps {
  readonly allowNegativeVotes: boolean;
  readonly onChange: (allowNegativeVotes: boolean) => void;
  readonly isDisabled?: boolean;
}
export default function NegativeVotingToggle(t0) {
  const $ = _c(24);
  const {
    allowNegativeVotes,
    onChange,
    isDisabled: t1
  } = t0;
  const isDisabled = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== allowNegativeVotes || $[1] !== isDisabled || $[2] !== onChange) {
    t2 = () => {
      if (!isDisabled) {
        onChange(!allowNegativeVotes);
      }
    };
    $[0] = allowNegativeVotes;
    $[1] = isDisabled;
    $[2] = onChange;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleToggle = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h3 className="tw-text-lg tw-font-semibold tw-text-iron-50 tw-mb-0 tw-mr-4">Allow Negative Votes</h3>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== allowNegativeVotes || $[6] !== handleToggle || $[7] !== isDisabled) {
    t4 = <input disabled={isDisabled} type="checkbox" id="toggle-negative-votes" checked={allowNegativeVotes} onChange={handleToggle} className="tw-sr-only" aria-labelledby="negative-votes-label" />;
    $[5] = allowNegativeVotes;
    $[6] = handleToggle;
    $[7] = isDisabled;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = `tw-block tw-overflow-hidden tw-h-6 tw-rounded-full ${isDisabled ? "tw-cursor-not-allowed tw-opacity-70" : "tw-cursor-pointer"} ${allowNegativeVotes ? "tw-bg-blue-600" : "tw-bg-iron-700"}`;
  const t6 = `tw-block tw-h-6 tw-w-6 tw-rounded-full tw-bg-white tw-transform tw-transition-transform ${allowNegativeVotes ? "tw-translate-x-6" : "tw-translate-x-0"} ${isDisabled ? "tw-opacity-70" : ""}`;
  let t7;
  if ($[9] !== t6) {
    t7 = <span className={t6} />;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t5 || $[12] !== t7) {
    t8 = <label id="negative-votes-label" htmlFor="toggle-negative-votes" className={t5} aria-hidden="true">{t7}</label>;
    $[11] = t5;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t4 || $[15] !== t8) {
    t9 = <div className="tw-flex tw-items-center tw-mb-4">{t3}<div className="tw-relative tw-inline-block tw-w-12 tw-align-middle tw-select-none">{t4}{t8}</div></div>;
    $[14] = t4;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const t10 = `tw-text-iron-400 tw-mb-4 ${isDisabled ? "tw-opacity-70" : ""}`;
  const t11 = allowNegativeVotes ? "Users can submit negative votes for drops. This allows for more nuanced voting but may lead to more contentious results." : "Only positive votes are allowed. This encourages constructive voting and simplifies the voting dynamics.";
  const t12 = isDisabled && " This setting cannot be changed.";
  let t13;
  if ($[17] !== t10 || $[18] !== t11 || $[19] !== t12) {
    t13 = <p className={t10}>{t11}{t12}</p>;
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t13 || $[22] !== t9) {
    t14 = <div className="tw-mt-6 tw-border-t tw-border-iron-700 tw-pt-6">{t9}{t13}</div>;
    $[21] = t13;
    $[22] = t9;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  return t14;
}